import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";

import styles from "./ValuesChart.module.css";

import { TraitContent } from "@dimensional-engineering/dimensional-models";
import useIsMobile from "@/helpers/useIsMobile";

export default function ValuesChart(props: TraitContent) {
  const [colors, setColors] = useState<string[] | []>([]);
  const list = [
    { name: "Investigative", color: "rgb(147, 203, 126)" },
    { name: "Artistic", color: "rgb(169, 255, 101)" },
    { name: "Social", color: "rgb(255, 198, 88)" },
    { name: "Enterprising", color: "rgb(82, 140, 255)" },
    { name: "Conventional", color: "rgb(196, 141, 222)" },
    { name: "Realistic", color: "rgb(142, 103, 195)" },
  ];
  const [dimensions, setDimensions] = useState<number[]>([25, 75]);
  const isMobile = useIsMobile();

  useEffect(() => {
    setColors([]);
    let array: string[] = [];
    props.traitDetails?.forEach((val) => {
      array.push(val.name);
    });

    list.forEach((l) => {
      let color: string;
      if (array.includes(l.name)) {
        color = l.color;
      } else {
        color = "#2D2927";
      }
      setColors((current) => [...current, color]);
    });

    isMobile ? setDimensions([25, 75]) : setDimensions([30, 90]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const option = {
    color: colors,
    label: {
      show: true,
      color: "#fffff2",
      fontSize: isMobile ? 10 : 12,
    },
    series: [
      {
        name: "Nightingale Chart",
        type: "pie",
        radius: dimensions,
        center: ["50%", "50%"],
        roseType: "radius",
        itemStyle: {
          borderRadius: 8,
          borderWidth: 1,
          borderColor: "white",
        },
        emphasis: {
          disabled: true,
        },
        data: [
          { value: 100, name: "Investigative" },
          { value: 100, name: "Artistic" },
          { value: 100, name: "Social" },
          { value: 100, name: "Enterprising" },
          { value: 100, name: "Conventional" },
          { value: 100, name: "Realistic" },
        ],
      },
    ],
  };

  return (
    <div className={styles.main}>
      <h2>Archetype Breakdown</h2>
      <ReactECharts
        style={{ maxHeight: "300px" }}
        option={option}
        notMerge={true}
        lazyUpdate={true}
      />
    </div>
  );
}
